import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import {
  Row,
  Col
} from 'reactstrap';
import Card from '../../shared/Card';
import Button from '../../shared/Button';
import styles from './styles.scss';


const CompanyUsers = ({ edit, users, companyId }) => (
  <Card header='Company Admins'>
    <Row>
      <If condition={users}>
        <Col xs={6}>
          <Choose>
            <When condition={users && users.length}>
              {users.map(({ id, firstName, lastName, contactInfo={}, email }) => (
                <p key={id}>
                  <label className='font-weight-bold'>
                    {`${firstName} ${lastName}`}
                  </label><br/>
                  <label className={classNames({
                    'mr-2': !!contactInfo.phone
                  })}>{contactInfo.phone}</label>
                  <a href={`mailto:${email}`}>{email}</a>
                </p>
              ))}
            </When>
            <Otherwise>
              There are no company admins
            </Otherwise>
          </Choose>
        </Col>
      </If>
      <If condition={edit}>
        <Col xs={6} className={classNames({ 'text-right': !!users })}>
          <Row>
            <Col className='mb-3'>
              <Link
                to={{
                  pathname: '/users',
                  state: { companyId }
                }}
                className={styles.link}
              >
                <Button className={`w-50 ${styles.button}`}>
                  Manage Users
                </Button>
              </Link>
            </Col>
          </Row>
          <Row>
            <Col>
              <Link
                to={{
                  pathname: '/user',
                  state: { companyId }
                }}
                className={styles.link}
              >
                <Button className={`w-50 ${styles.button}`}>
                  Add Company User
                </Button>
              </Link>
            </Col>
          </Row>
        </Col>
      </If>
    </Row>
  </Card>
);

CompanyUsers.propTypes = {
  edit: PropTypes.bool,
  users: PropTypes.array,
  companyId: PropTypes.string
};

export default CompanyUsers;


// WEBPACK FOOTER //
// src/components/companyDetails/CompanyUsers/index.jsx